// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EylQ","content":"styles_content__2NsLQ"};